import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { RealtimePostgresChangesPayload } from "@supabase/supabase-js";

/**
 * Hook para escutar mudanças em tempo real em uma tabela do Supabase,
 * filtrada pelo studio_id do usuário logado.
 */
export function useRealtimeSubscription<T extends { id: string }>(
  table: string,
  callback: () => void
) {
  const [studioId, setStudioId] = useState<string | null>(null);

  useEffect(() => {
    const getSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user?.id) {
        setStudioId(session.user.id);
      }
    };
    getSession();
  }, []);

  useEffect(() => {
    if (!studioId) return;

    // Criar o canal para escutar mudanças na tabela
    const channel = supabase
      .channel(`realtime:${table}`)
      .on(
        "postgres_changes",
        {
          event: "*", // Listen to INSERT, UPDATE, and DELETE
          schema: "public",
          table: table,
          filter: `studio_id=eq.${studioId}`,
        },
        (payload: RealtimePostgresChangesPayload<T>) => {
          console.log(`[Realtime] Mudança detectada na tabela ${table}:`, payload);
          callback();
        }
      )
      .subscribe((status) => {
        console.log(`[Realtime] Status da inscrição para ${table}:`, status);
      });

    return () => {
      supabase.removeChannel(channel);
    };
  }, [table, studioId, callback]);
}
